<template>
    <q-dialog v-model="showModal">
        <q-card style="width: 500px; max-width: 450vw;">
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">{{$t('important')}}</div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>

            <q-card-section>
                <p>{{$t('recipients.exchange_rate_and_payment_amounts_will_be_locked')}}:</p>
                <ul>
                    <li v-html="$t('recipients.i_confirm_i_will_be_paying_from_my_bank_account', {name: userFullName})"></li>
                    <li v-html="$t('recipients.i_confirm_i_m_able_to_make_the_payment_asap')"></li>
                </ul>
            </q-card-section>

            <q-card-actions class="justify-end">
                <q-btn :label="$t('i_confirm')" color="primary" @click="$emit('confirm')" :loading="loading"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

export default {
    name: "MakeSureModal",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        userFullName: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
